import { Component, OnInit, inject } from '@angular/core';
import { TIPPY_REF } from '@ngneat/helipopper';

@Component({
  selector: 'app-sources-tooltip',
  templateUrl: './sources-tooltip.component.html',
  styleUrls: ['./sources-tooltip.component.scss'],
})
export class SourcesTooltipComponent implements OnInit {
  tippy = inject(TIPPY_REF);

  constructor() {}

  ngOnInit() {}
}
